module.exports = __webpack_public_path__ + "static/media/payment.7f63b526.webp";